class productCalculator extends HTMLElement {
    static get observedAttributes() {
        return ['data-quantity', 'data-duration', 'data-weight', 'data-price']; 
    }

    constructor() {
        super();
        this.initialData = JSON.parse(this.querySelector('#calculator-data').innerHTML);
        this.weightInput = this.querySelector('#weight-input');
        this.durationInputs = this.querySelectorAll('[name="duration"]');
        this.placeholders = this.querySelectorAll('.placeholder');
        this.variantTitle = this.querySelector('[data-variant-title]');
        this.productQuantity = this.querySelector('[data-product-quantity]');
        this.productDuration = this.querySelector('[data-product-duration]');
        this.productPrice = this.querySelector('[data-product-price]');
        this.calculateButton = this.querySelector('[data-start]');
        this.recalculateButton = this.querySelector('[data-end]');
        this.calculation = this.querySelector('[data-calculation]');
        this.results = this.querySelector('[data-results]');
        this.calculateProductQuantity();
        this.setDuration();
        this.showResults();
        this.hideResults();
    }

    get quantity() {
        return this.dataset.quantity;
    }

    get duration() {
        return this.dataset.duration;
    }

    get weight() {
        return this.dataset.weight;
    }

    get price() {
        return this.dataset.price;
    }

    connectedCallback() {
        document.addEventListener('variant-change', (event)=> {
           if (event) {
            this.variantTitle.innerText = event.detail.variant.title;

            const variant = this.initialData.variants.find(variant => variant.id ===  event.detail.variant.id);
            if (variant) {
                this.dataset.weight = variant.net_weight;
                setTimeout(()=> {
                    const price = this.getSelectedPlanPrice();
                    this.dataset.price = price !== null ? price : variant.price;
                }, 400)
            }
           }
        })

        document.addEventListener('selling-plan::selected', (event)=> {
            // Ignore plan changes from widgets in the quick-add modal
            if (event.detail?.widget?.closest('quick-add-modal')) return;
            const price = this.getSelectedPlanPrice();
            if (price !== null) this.dataset.price = price;
        })
    }

    // Price of the selected plan in the page's own (non quick-add) recharge widget
    getSelectedPlanPrice() {
        const widget = Array.from(document.querySelectorAll('recharge-widget')).find(el => !el.closest('quick-add-modal'));
        const currentPlan = widget?.querySelector('.recharge-radio__input:checked');
        if (!currentPlan) return null;
        const priceEl = widget.querySelector(`[data-price-type="${currentPlan.dataset.planType}"]`);
        return priceEl ? Number(priceEl.dataset.price) : null;
    }

    attributeChangedCallback() {
        this.calculateDailyUsage();
        this.calculateDuration();
        this.calculatePrice();
        this.updatePlaceholders();
    }

    calculateProductQuantity() {
        this.weightInput.addEventListener('input', ()=> {
            if (this.weightInput.value > 1 || this.weightInput.value !== '') {
                this.weightInput.classList.remove('error');
                if (this.weightInput.value.length > 3) {
                    const newValue = String(this.weightInput.value).substring(0,3);
                    this.weightInput.value = Number(newValue);
                }
                this.dataset.quantity = (this.weightInput.value * this.initialData.factor).toFixed(2);
            } 
        })
    }

    setDuration() {
        this.durationInputs.forEach((input)=> {
            input.addEventListener('change', ()=> {
                this.dataset.duration = input.value;
            })
        })
    }

    calculateDailyUsage() {
        switch (this.duration) {
            case 'Täglich':
                this.productQuantity.innerText = `${(this.quantity * 1).toFixed(2)} g`;
                break;
            case 'Wöchentlich':     
            this.productQuantity.innerText = `${(this.quantity * 7).toFixed(2)} g`;
            break;
            case 'Monatlich':
                this.productQuantity.innerText = `${Math.round(this.quantity * 30.42)} g`;
            break;
        }
    }

    calculateDuration() {
        switch (this.duration) {
            case 'Täglich':
                this.productDuration.innerText = `${Math.floor(this.weight / this.quantity)} Tage`;
                break;
            case 'Wöchentlich':
                const weekQuantity = Math.floor(this.weight / this.quantity ) / 7;
                if(Number.isInteger(weekQuantity)) {
                    this.productDuration.innerText = `${weekQuantity} Wochen`;
                } else {
                    this.productDuration.innerText =  `${String(weekQuantity.toFixed(1)).replace('.', ',')} Wochen`;
                }  
                break;
            case 'Monatlich':
                const monthQuantity = Math.floor(this.weight / this.quantity) / 30.42;
                if(Number.isInteger(monthQuantity)) {
                    this.productDuration.innerText = `${monthQuantity} Monate`;
                } else {
                    this.productDuration.innerText = `${String(monthQuantity.toFixed(1)).replace('.',',')} Monate`;
                }  
                break;
        }
    }

    calculatePrice() {
        switch (this.duration) {
            case 'Täglich':
                const dayPrice = this.price / 100 / this.weight * this.quantity;
                this.productPrice.innerText = `€ ${String(((dayPrice * 100) / 100).toFixed(2)).replace('.', ',')}`;
                break;
            case 'Wöchentlich':
                const weekPrice = this.price / 100 / this.weight * this.quantity * 7;
                this.productPrice.innerText = `€ ${String(((weekPrice * 100) / 100).toFixed(2)).replace('.', ',')}`;
                break;
            case 'Monatlich':
                const monthPrice =  this.price / 100 / this.weight * this.quantity * 30.42;
                this.productPrice.innerText = `€ ${String(((monthPrice * 100) / 100).toFixed(2)).replace('.', ',')}`;  
                break;
        }
    }

    updatePlaceholders() {
        this.placeholders.forEach((placeholder) => {
            switch (this.duration) {
                case 'Täglich':
                    placeholder.querySelector('em').innerText = 'Tag';
                    break;
                case 'Wöchentlich':
                    placeholder.querySelector('em').innerText = 'Wochen';
                    break;
                case 'Monatlich':
                    placeholder.querySelector('em').innerText = 'Monat';
                    break;
            }   
        })
    }

    showResults() {
        this.calculateButton.addEventListener('click', ()=> {
            if (this.weightInput.value <= 1 || this.weightInput.value === '') {
                this.weightInput.focus();
                this.weightInput.classList.add('error');
            } else {
                this.weightInput.classList.remove('error');
                this.results.style.display = 'block';
                this.calculation.style.display = 'none';
            }
        })
    }

    hideResults() {
        this.recalculateButton.addEventListener('click', ()=> {
            this.results.style.display = 'none';
            this.calculation.style.display = 'block';
        })
    }
}

customElements.define('product-calculator', productCalculator)